export default __webpack_public_path__ + "static/media/litho-demo-spa-salon.43ca4b3c.jpg";